export default __webpack_public_path__ + "static/media/icon_ticket_open.de54013b.svg";